import { render, staticRenderFns } from "./practiceDaily.vue?vue&type=template&id=f3926cb6&scoped=true"
import script from "./practiceDaily.vue?vue&type=script&lang=js"
export * from "./practiceDaily.vue?vue&type=script&lang=js"
import style0 from "./practiceDaily.vue?vue&type=style&index=0&id=f3926cb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3926cb6",
  null
  
)

export default component.exports